var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "catalog-wizard" }, [
    _c(
      "div",
      { staticClass: "catalog-wizard-steps", attrs: { role: "tablist" } },
      _vm._l(_vm.steps, function (step, index) {
        return _c(
          "button",
          {
            key: step.key,
            staticClass: "catalog-wizard-step",
            class: {
              "is-active": step.key === _vm.current,
              "is-done": _vm.isDone(step.key) && step.key !== _vm.current,
              "is-locked": !_vm.isReachable(step.key),
            },
            attrs: { type: "button", disabled: !_vm.isReachable(step.key) },
            on: {
              click: function ($event) {
                return _vm.goTo(step.key)
              },
            },
          },
          [
            _c(
              "span",
              { staticClass: "catalog-wizard-step-badge" },
              [
                _vm.isDone(step.key) && step.key !== _vm.current
                  ? _c("feather-icon", {
                      attrs: { icon: "CheckIcon", svgClasses: "w-4 h-4" },
                    })
                  : [_vm._v(_vm._s(index + 1))],
              ],
              2
            ),
            _c("span", { staticClass: "catalog-wizard-step-text" }, [
              _c("span", { staticClass: "catalog-wizard-step-title" }, [
                _vm._v(_vm._s(step.title)),
              ]),
              step.hint
                ? _c("small", { staticClass: "catalog-wizard-step-hint" }, [
                    _vm._v(_vm._s(step.hint)),
                  ])
                : _vm._e(),
            ]),
          ]
        )
      }),
      0
    ),
    _c("div", { staticClass: "catalog-wizard-body" }, [_vm._t("default")], 2),
    _c("div", { staticClass: "catalog-wizard-footer" }, [
      _c(
        "div",
        { staticClass: "catalog-wizard-footer-info" },
        [_vm._t("footer-info")],
        2
      ),
      _c(
        "div",
        { staticClass: "catalog-wizard-footer-actions" },
        [
          _vm.currentIndex > 0
            ? _c(
                "b-button",
                {
                  attrs: { variant: "outline-secondary", disabled: _vm.busy },
                  on: {
                    click: function ($event) {
                      return _vm.$emit("prev")
                    },
                  },
                },
                [
                  _c("feather-icon", {
                    staticClass: "mr-50",
                    attrs: { icon: "ArrowLeftIcon" },
                  }),
                  _c("span", { staticClass: "align-middle" }, [
                    _vm._v(_vm._s(_vm.$t("catalog.wizard.back"))),
                  ]),
                ],
                1
              )
            : _vm._e(),
          _vm._t("footer-actions", function () {
            return [
              !_vm.isLast
                ? _c(
                    "b-button",
                    {
                      attrs: {
                        variant: "primary",
                        disabled: _vm.nextDisabled || _vm.busy,
                      },
                      on: {
                        click: function ($event) {
                          return _vm.$emit("next")
                        },
                      },
                    },
                    [
                      _c("span", { staticClass: "align-middle" }, [
                        _vm._v(
                          _vm._s(
                            _vm.nextLabel || _vm.$t("catalog.wizard.continue")
                          )
                        ),
                      ]),
                      _c("feather-icon", {
                        staticClass: "ml-50",
                        attrs: { icon: "ArrowRightIcon" },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
            ]
          }),
        ],
        2
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }